import config from 'constants/config'
import { Experiments } from 'constants/experiments'
import { getOptimizelyExperimentDecisionVariation } from 'lib/optimizely/optimizelyUtils'
import themes from 'constants/themes'
// oxlint-disable-next-line no-restricted-imports - Imported to support rebrand theme selection
import { luxuryEscapesTheme } from 'constants/themes/luxuryescapes'
// oxlint-disable-next-line no-restricted-imports - Imported to support rebrand theme selection
import { luxuryEscapesRebrandTheme } from 'constants/themes/luxuryescapesRebrand'

export type RebrandVersion = 'legacy' | 'rebrand'
export type RebrandTreatment = 'control' | 'on'

export const REBRAND_TREATMENT = 'on'
export const REBRAND_CONTROL = 'control'
export const REBRAND_PALETTE_CLASS = 'app-palette-rebrand'

function isRebrandEnabledBrand() {
  return config.BRAND === 'luxuryescapes'
}

export function resolveRebrandTreatment(decision: unknown): RebrandTreatment {
  return decision === REBRAND_TREATMENT ? REBRAND_TREATMENT : REBRAND_CONTROL
}

/**
 * Only the explicit rebrand treatment can select the rebrand palette. Keeping
 * this conversion narrow makes absent, control, and unknown decisions legacy.
 */
export function resolveRebrandVersion(decision: unknown): RebrandVersion {
  return resolveRebrandTreatment(decision) === REBRAND_TREATMENT ? 'rebrand' : 'legacy'
}

export function getRebrandTreatment(state: App.State): RebrandTreatment {
  if (!isRebrandEnabledBrand()) {
    return REBRAND_CONTROL
  }

  return resolveRebrandTreatment(
    getOptimizelyExperimentDecisionVariation(state, Experiments.croRebrand.id),
  )
}

export function getRebrandVersion(state: App.State): RebrandVersion {
  if (!isRebrandEnabledBrand()) {
    return 'legacy'
  }

  return resolveRebrandVersion(
    getOptimizelyExperimentDecisionVariation(state, Experiments.croRebrand.id),
  )
}

export function getBrandTheme(brand: string, version: RebrandVersion): App.Design.Theme {
  if (brand === 'luxuryescapes') {
    return version === 'rebrand'
      ? luxuryEscapesRebrandTheme
      : luxuryEscapesTheme
  }

  return themes[brand] ?? themes.luxuryescapes
}
